/**
 * @file ImportSpreadsheetButton.tsx
 * @description A reusable button component for triggering spreadsheet import functionality.
 * This component provides a consistent UI element for initiating the import process
 * across different parts of the application.
 */

import React from "react";

interface ImportSpreadsheetButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const ImportSpreadsheetButton: React.FC<ImportSpreadsheetButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <div className="inline-flex gap-2 text-2xl">
      oppure
      <button
        onClick={onClick}
        disabled={disabled}
        className="flex items-center font-normal transition-colors duration-200 gap-2text-2xl text-primary hover:text-primary-focus focus:outline-none"
      >
        Importa file Excel
      </button>
    </div>
  );
};

export default ImportSpreadsheetButton;
